// service/crm/hooks/useUploadContactImportFileMutation.ts

import { useMutation } from "@tanstack/react-query";
import { contactImportApi } from "service/crm/api/contactImport";
import { ContactImportUpload } from "types/crm/contactImport";

/**
 * Uploads the selected import file and yields the handle the next step needs.
 *
 * Nothing is cached: each selection is a fresh upload, so there are no queries
 * to invalidate.
 */
export const useUploadContactImportFileMutation = () =>
  useMutation<ContactImportUpload, unknown, File>({
    mutationFn: contactImportApi.uploadImportFile,
  });
